import { render, staticRenderFns } from "./SubmitRequestVisaPopUp.vue?vue&type=template&id=f0d37658&scoped=true&lang=pug"
import script from "./SubmitRequestVisaPopUp.vue?vue&type=script&lang=ts"
export * from "./SubmitRequestVisaPopUp.vue?vue&type=script&lang=ts"
import style0 from "./SubmitRequestVisaPopUp.vue?vue&type=style&index=0&id=f0d37658&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d37658",
  null
  
)

/* custom blocks */
import block0 from "./SubmitRequestVisaPopUp.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FSubmitRequestVisaPopUp.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports